import { RoleSigningStatus } from 'services/api/api-client.types.ts';
import { assertNever } from 'helpers/assert-never.ts';
import i18n from 'i18next';
import styles from './IconStyles.module.scss';

export function getTextFromStatus(status: RoleSigningStatus): string {
  switch (status) {
    case RoleSigningStatus.NotStarted:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.not_started',
      );
    case RoleSigningStatus.WaitingForItsTurn:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.waiting_for_its_turn',
      );
    case RoleSigningStatus.WaitingForSignature:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.waiting_for_signature',
      );
    case RoleSigningStatus.Signed:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.signed',
      );
    case RoleSigningStatus.SignedByAnotherRole:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.signed_by_another_role',
      );
    case RoleSigningStatus.InvalidSignature:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.invalid_signature',
      );
    case RoleSigningStatus.InvalidSigner:
      return i18n.t(
        'Page.Projects.ProjectDetailsPage.FoldersTree.Signatures.invalid_signer',
      );
    default:
      assertNever(status);
  }
}

export function getStyleFromStatus(
  status: RoleSigningStatus,
  icon: boolean,
): string {
  switch (status) {
    case RoleSigningStatus.NotStarted:
      return icon ? styles.notStartedIcon : styles.notStarted;
    case RoleSigningStatus.WaitingForItsTurn:
      return icon ? styles.notStartedIcon : styles.notStarted;
    case RoleSigningStatus.WaitingForSignature:
      return icon ? styles.waitingForSignatureIcon : styles.waitingForSignature;
    case RoleSigningStatus.Signed:
      return icon ? styles.signedIcon : styles.signed;
    case RoleSigningStatus.SignedByAnotherRole:
      return icon ? styles.signedIcon : styles.signed;
    case RoleSigningStatus.InvalidSignature:
      return icon ? styles.failedIcon : styles.failed;
    case RoleSigningStatus.InvalidSigner:
      return icon ? styles.failedIcon : styles.failed;
    default:
      assertNever(status);
  }
}
